<div class="content d-flex flex-column vi-gap-24">
  <!-- ACCEPTED -->
  <ng-container *ngIf="appointment.status === 'ACCEPTED'">
    <headline-with-icon [headline]="'APPOI.PROCESSED_PAGE.HEADLINE_ACCEPTED' | translate"
                        [icon]="'success'"
                        [text]="'APPOI.GET_IN_CONTACT' | translate:{
              viessmannTechnicalServicePhone: appointment.viessmannTechnicalServicePhone,
              viessmannTechnicalServiceMail: appointment.viessmannTechnicalServiceMail,
              number: appointment.orderNumber
              }">
    </headline-with-icon>
    <mat-card>
      <mat-card-content>
        <appointment-details [appointment]="appointment" [settings]="settings"></appointment-details>
      </mat-card-content>
      <mat-card-actions>
        <button (throttledClick)="closeFrameEvent()"
                *ngIf="embedModeEnabled"
                [throttleTime]="5000"
                appPreventDoubleClick
                class="vi-button"
                color="primary"
                mat-flat-button>{{ 'APPOI.BUTTON.CLOSE' | translate }}
        </button>
      </mat-card-actions>
    </mat-card>
    <ng-container *ngIf="!embedModeEnabled">
      <viessmann-home-banner *ngIf="appointment.businessPartnerIsEndUser && settings.showLinkToViessmannHome"
                             [appointmentId]="appointment.id" [factoryId]="appointment.factoryId"
      ></viessmann-home-banner>
      <div *ngIf="!appointment.businessPartnerIsEndUser && settings.showLinkToHeatingSystemsOverview" class="actions">
        <button-heating-systems-overview [installation]="appointment.installation"></button-heating-systems-overview>
      </div>
    </ng-container>
  </ng-container>

  <!-- ALTERNATIVE_TIME_SLOT_BOOKED_BY_CUSTOMER -->
  <ng-container *ngIf="appointment.status === 'ALTERNATIVE_TIME_SLOT_BOOKED_BY_CUSTOMER'">
    <headline-with-icon
      [headline]="'APPOI.PROCESSED_PAGE.HEADLINE_ALTERNATIVE_TIME_SLOT_BOOKED_BY_CUSTOMER' | translate"
      [icon]="'success'"
      [text]="'APPOI.GET_IN_CONTACT' | translate:{
              viessmannTechnicalServicePhone: appointment.viessmannTechnicalServicePhone,
              viessmannTechnicalServiceMail: appointment.viessmannTechnicalServiceMail,
              number: appointment.orderNumber
              }">
    </headline-with-icon>
    <mat-card>
      <mat-card-content>
        <appointment-details [appointment]="appointment" [settings]="settings"></appointment-details>
      </mat-card-content>
      <mat-card-actions>
        <button (throttledClick)="closeFrameEvent()"
                *ngIf="embedModeEnabled"
                [throttleTime]="5000"
                appPreventDoubleClick
                class="vi-button"
                color="primary"
                mat-flat-button>{{ 'APPOI.BUTTON.CLOSE' | translate }}
        </button>
      </mat-card-actions>
    </mat-card>
    <ng-container *ngIf="!embedModeEnabled">
      <viessmann-home-banner *ngIf="appointment.businessPartnerIsEndUser && settings.showLinkToViessmannHome"
                             [appointmentId]="appointment.id" [factoryId]="appointment.factoryId"
      ></viessmann-home-banner>
      <div *ngIf="!appointment.businessPartnerIsEndUser && settings.showLinkToHeatingSystemsOverview" class="actions">
        <button-heating-systems-overview [installation]="appointment.installation"></button-heating-systems-overview>
      </div>
    </ng-container>
  </ng-container>

  <!-- DECLINED -->
  <ng-container *ngIf="appointment.status === 'DECLINED'">
    <headline-with-icon [headline]="'APPOI.PROCESSED_PAGE.HEADLINE_DECLINED' | translate" [icon]="'warn'">
    </headline-with-icon>
    <mat-card>
      <mat-card-content>
        <span [innerHTML]="'APPOI.GET_IN_CONTACT' | translate:{
            viessmannTechnicalServicePhone: appointment.viessmannTechnicalServicePhone,
            viessmannTechnicalServiceMail: appointment.viessmannTechnicalServiceMail,
            number: appointment.orderNumber
          }"></span>
      </mat-card-content>
      <mat-card-actions *ngIf="embedModeEnabled">
        <button (throttledClick)="closeFrameEvent()"
                [throttleTime]="5000"
                appPreventDoubleClick
                class="vi-button"
                color="primary"
                mat-flat-button>{{ 'APPOI.BUTTON.CLOSE' | translate }}
        </button>
      </mat-card-actions>
    </mat-card>
    <ng-container *ngIf="!embedModeEnabled">
      <viessmann-home-banner *ngIf="appointment.businessPartnerIsEndUser && settings.showLinkToViessmannHome"
                             [appointmentId]="appointment.id" [factoryId]="appointment.factoryId"
      ></viessmann-home-banner>
      <div *ngIf="!appointment.businessPartnerIsEndUser && settings.showLinkToHeatingSystemsOverview" class="actions">
        <button-heating-systems-overview [installation]="appointment.installation"></button-heating-systems-overview>
      </div>
    </ng-container>
  </ng-container>

  <!-- EXPIRED -->
  <ng-container *ngIf="appointment.status === 'EXPIRED'">
    <headline-with-icon [headline]="'APPOI.PROCESSED_PAGE.HEADLINE_EXPIRED' | translate" [icon]="'warn'">
    </headline-with-icon>
    <mat-card>
      <mat-card-content>
        <span [innerHTML]="'APPOI.GET_IN_CONTACT' | translate:{
            viessmannTechnicalServicePhone: appointment.viessmannTechnicalServicePhone,
            viessmannTechnicalServiceMail: appointment.viessmannTechnicalServiceMail,
            number: appointment.orderNumber
          }"></span>
      </mat-card-content>
      <mat-card-actions *ngIf="embedModeEnabled">
        <button (throttledClick)="closeFrameEvent()"
                [throttleTime]="5000"
                appPreventDoubleClick
                class="vi-button"
                color="primary"
                mat-flat-button>{{ 'APPOI.BUTTON.CLOSE' | translate }}
        </button>
      </mat-card-actions>
    </mat-card>
  </ng-container>

  <!-- DELETED -->
  <ng-container *ngIf="appointment.status === 'DELETED'">
    <headline-with-icon [headline]="'APPOI.PROCESSED_PAGE.HEADLINE_DELETED' | translate" [icon]="'warn'">
    </headline-with-icon>
    <mat-card>
      <mat-card-content>
        <span [innerHTML]="'APPOI.GET_IN_CONTACT' | translate:{
            viessmannTechnicalServicePhone: appointment.viessmannTechnicalServicePhone,
            viessmannTechnicalServiceMail: appointment.viessmannTechnicalServiceMail,
            number: appointment.orderNumber
          }"></span>
      </mat-card-content>
      <mat-card-actions *ngIf="embedModeEnabled">
        <button (throttledClick)="closeFrameEvent()"
                [throttleTime]="5000"
                appPreventDoubleClick
                class="vi-button"
                color="primary"
                mat-flat-button>{{ 'APPOI.BUTTON.CLOSE' | translate }}
        </button>
      </mat-card-actions>
    </mat-card>
  </ng-container>

</div>
